import {create} from 'zustand';

interface LoaderState { 
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;

    isLoadingDocuments: boolean;
    setIsLoadingDocuments: (isLoadingDocuments: boolean) => void;

    progress: number;
    setProgress: (progress: number) => void;
}

export const useLoaderStore = create<LoaderState>((set) => ({
    isLoading: false,
    setIsLoading: (isLoading) => set({isLoading}),

    isLoadingDocuments: false,
    setIsLoadingDocuments: (isLoadingDocuments) => set({isLoadingDocuments}),

    progress: 0,
    setProgress: (progress) => set({progress}),
}));